// Mirrors the backend rule: a missing/unset emailVerified flag means NOT verified.
// The platform super admin is exempt, exactly like the backend guard.
export const isEmailVerified = (user) =>
  Boolean(user?.isSuperAdmin || user?.email === 'admin@specard.net' || user?.emailVerified === true);

export const PROJECT_ACCESS_VERIFICATION_MESSAGE =
  'Please verify your email address to access projects.';

export const PROJECT_CREATE_VERIFICATION_MESSAGE =
  'Please verify your email address before creating a project.';
